/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import './GoalTile.css';
import { Box, Typography } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';

interface contentTileType {
  goalName: string;
  goalProgress: string;
  daysLeft: any;
  onClick?: any;
}

const GoalTile: React.FC<contentTileType> = ({
  daysLeft,
  goalName,
  goalProgress,
  onClick,
}) => {
  return (
    <Box
      style={{
        backgroundColor: '#FAFAFA',
        borderRadius: '1em',
        padding: '0.5em',
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          style={{
            fontSize: '0.85em',
            color: '#1C1D21',
            fontWeight: 'bold',
          }}
        >
          {goalName}
        </Typography>
        <Typography
          style={{
            width: '1.5em',
            height: '1.5em',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#E6E8F0',
            borderRadius: '50%',
          }}
        >
          <i className="las la-angle-right" />
        </Typography>
      </Box>
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginTop: '0.5em',
        }}
      >
        <Typography
          style={{
            fontSize: '0.75em',
            color: '#8181A5',
            fontFamily: 'Lato',
          }}
        >
          <i className="las la-list-alt" /> {`${goalProgress}% Progress`}
        </Typography>
        <Typography
          style={{
            fontSize: '0.75em',
            color: '#1C1D21',
            fontWeight: 'bold',
          }}
        >
          {daysLeft > 1 ? `${daysLeft} days left` : `${daysLeft} day left`}
        </Typography>
      </Box>
      <Box style={{ marginTop: '0.5em' }}>
        <LinearProgress
          variant="determinate"
          value={49}
          sx={{
            '&.MuiLinearProgress-root': {
              backgroundColor: '#E6E8F0',
              borderRadius: '5px',
            },
            '& .MuiLinearProgress-bar': {
              backgroundColor: '#4CAF50',
              boxShadow: '#00000029',
              borderRadius: '5px',
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default GoalTile;
